import { CurrentUser } from 'libs/hooks/useCurrentUser';
import { hasClassificationAccess } from 'libs/classificationUserType';

/**
 * @deprecated Use getClassificationUserType or hasClassificationAccess from
 * 'libs/classificationUserType' directly for new code.
 * @param {CurrentUser} currentUser - The current user object
 * @return {boolean} Whether the user has classification access
 */
export const isClassificationSmeUser = (currentUser: CurrentUser): boolean => {
  return hasClassificationAccess(currentUser);
};
